import "../styles/normalize.css";
import "../styles/ant-input-number.css";
import "../styles/ant-input-date-picker.css";
import "../styles/ant-input.css";
import "../styles/ant-tooltip.css";
import "../styles/globals.css";

import type { AppProps } from "next/app";
import { IntlProvider } from "@atlas/text";
import StylesProvider from "@atlas/uicorn/lib/System/StylesProvider";
import { HelpCenterTheme } from "../lib/load-company-settings";

function HelpCenterApp({ Component, pageProps }: AppProps) {
  return (
    /* The shared `@atlas/uicorn` components format their labels through
     * `@atlas/text`'s `useIntl`, which needs a provider in the tree: without
     * one every page that renders an icon throws
     * "[React Intl] Could not find required `intl` object" during SSR and 500s.
     * The locale is the one the page is being served in (the URL prefix, else
     * the company default) from `getAppSettings`, so the chrome and the
     * content agree. `IntlProvider` always merges the English catalog
     * underneath, which is the documented fallback. */
    <IntlProvider locale={pageProps.appSettings?.locale}>
      <StylesProvider
        theme={pageProps.appSettings?.theme ?? HelpCenterTheme.AUTO}
      >
        <Component {...pageProps} />
      </StylesProvider>
    </IntlProvider>
  );
}

export default HelpCenterApp;
